import TAGSORT from "../class/tagsort";

const [ w, d, l, mq ] = [window, document, location, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = () => {
  // テンプレート上書き
  const itemTemplate = `
    <div class="rwd002-list-content is-list-12" :class="[ 'is-paged-' + paged ]">
      <div class="rwd002-list-content__inner">
        <transition-group tag="ul" class="rwd002-list-content__list" name="fade" mode="out-in">
          <li class="rwd002-list-content__item" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
            <a :href="article.href" class="rwd002-list-content__link">
              <figure class="rwd002-list-content__thumb">
                <img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="rwd002-list-content__thumb-img">
                <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
              </figure>
              <div class="rwd002-list-content__body">
                <p class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</p>
                <h5 class="title">{{ article.title }}</h5>
                <p class="desc" v-if="article.desc.length">{{ article.desc }}</p>
                <div class="tags" v-if="article.keywords != null">
                  <span class="tag" v-for="keyword in article.keywords">#{{keyword}}</span>
                </div>
              </div><!-- /.rwd002-list-content__body -->
            </a>
            <!-- /.rwd002-list-content__link -->
          </li>
          <!-- /.rwd002-list-content__item -->
        </transition-group>
        <!-- /.rwd002-list-content__list -->
      </div>
      <!-- /.rwd002-list-content__inner -->
    </div>
    <!-- /.rwd002-list-content -->
  `;

  const relatedItemTemplate = `
  <div class="rwd002-related-content is-list-12" v-if="relatedArticles.length">
    <div class="rwd002-related-content__inner">
      <h3 class="rwd002-related-content__title">関連記事</h3>
      <!-- /.rwd002-related-content__title -->
      <ul class="rwd002-related-content__list">
        <li class="rwd002-related-content__item" v-for="( article, ind ) in relatedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <a :href="article.href" class="rwd002-related-content__link">
            <figure class="rwd002-related-content__thumb"><img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="rwd002-related-content__thumb-img"></figure>
            <div class="rwd002-related-content__body">
              <p class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</p>
              <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
              <h5 class="title">{{ article.title }}</h5>
              <p class="desc">{{ article.desc }}</p>
            </div><!-- /.rwd002-related-content__body -->
          </a>
          <!-- /.rwd002-related-content__link -->
        </li>
        <!-- /.rwd002-related-content__item -->
      </ul>
      <!-- /.rwd002-related-content__list -->
    </div>
    <!-- /.rwd002-related-content__inner -->
  </div>
  <!-- /.rwd002-related-content -->
  `;

  d.addEventListener('tagsort.beforeInit', e => {
    const pagetop = d.querySelector('.rwd002-pagetop__wrap');
    pagetop.insertAdjacentHTML('beforebegin', `<taglist />`);
  });
  
  const Tagsort = new TAGSORT({
    // tagsortのオプション設定（以下デフォルト値）
    list: {
      el: '.rwd002-list-content',
      perpage: 20, // 一度に表示する記事数
      itemTemplate, // テンプレートの上書き（falseでデフォルト表示）
      bodyLength: 100, // 記事本文の文字数
      addComponent: [], // 一覧用Vueオブジェクトにコンポーネント追加：要{name}
      addData: {}, // 一覧用Vueオブジェクトのdataプロパティ拡張
      addMethods: {}, // 一覧用Vueオブジェクトのmethodプロパティ拡張
      addMounted(){}, // 一覧用Vueのmountedの最後で実行
    },
    pagination: {
      el: '.rwd002-pagination', // paginationのVUEオブジェクト上書き
      template: false, // テンプレートの上書き（falseでデフォルト表示）
    }, 
    taglist: {
      container: !d.body.classList.contains('is--list')? '.rwd002-pagination': false,
      disp_list: 'head', // head / foot / both(true) / append / prepend
      disp_detail: false, // head / foot / both(true) / append / prepend
      minimumTagAmount : 12, // タグの最低表示数
      hideUselessTags : 0, // 最低使用回数
      addAll: 'ALL', // カテゴリにALLを追加するか [ボタン名 / false]
      btnHtml: {
        open: `全てを表示<i class="fa-solid fa-angle-down fa-xs ms-1"></i>`,
        close: `一部のみ表示<i class="fa-solid fa-angle-up fa-xs ms-1"></i>`,
      }
    }, 
    related: {
      disp_detail: true,
      itemTemplate: relatedItemTemplate,
      sortType: 'tag', // or category
      amount: 3
    },
  });

  // 表示プロセス実行（必須）
  // 内部でinit後に実行されます。各クラスのRenderもここで実行されます。
  Tagsort.render();
};

const jqInit = () => false;

export default function NEWS () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
}